//
// Product Attributes
//
// ---------------------------------------------------------------------------
'use strict';

const config = {
    target: '.js-product-attributes-expand',
    selector: '.c-product-attributes__table',
    maxItems: 5,
    hiddenClass: 'is-hidden'
};

$(document).ready(function() {
    $(config.selector).each(function() {
        $(this).find('tr').filter(':gt(' + (config.maxItems - 1) + ')').addClass(config.hiddenClass);
    });
});

$(config.target).on('click', function(e) {
    e.preventDefault();

    let link = $(e.target);
    link.prev().find('tr').removeClass(config.hiddenClass);
    link.remove();
});



// WEBPACK FOOTER //
// ./src/js/components/product-attributes.js